/**
 * This file is used to import Vue components that we want to make available
 * globally. For example, a Spinner component that is used on many pages; it
 * would be annoying to have to import that component on every page and
 * component we want to include it in.
 */
import Vue from 'vue';
import Spinner from '~/components/Spinner.vue';

Vue.component('Spinner', Spinner);